import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
import useGetHook from "../../customHooks/useGetHook";
import { getApiData } from "../../helpers/AxiosInstance";

const Overview = (props) => {
  const { handleIsActive, handleIsPublic } = props;
  const navigate = useNavigate();

  const [submissionCounts, setSubmissionCounts] = useState({});

  const { data, isLoading } = useGetHook({
    queryKey: ["pinned-forms"],
    url: APIS.FORM,
    params: { limit: 10, offset: 0, pin: true },
  });

  const pinnedResults =
    data?.results?.filter((form: any) => form.pin === true) || [];

  useEffect(() => {
    const fetchCounts = async () => {
      if (data?.results && data.results.length > 0) {
        const countsObj = { ...submissionCounts };

        try {
          await Promise.all(
            data.results.map(async (form) => {
              const res = await getApiData(APIS.FORM_DATA, {
                limit: 1,
                offset: 0,
                form: form.id,
              });
              if (res && res.status === 200) {
                countsObj[form.id] = res.data.count || 0;
              }
            }),
          );
          setSubmissionCounts(countsObj);
        } catch (err) {
          console.error("error:", err);
        }
      }
    };

    fetchCounts();
  }, [data?.results]);

  const defaultColums = [
    {
      header: "Title",
      accessorKey: "title",
      cell: NACell,
    },
    {
      header: "Type",
      accessorKey: "form_type",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      ),
    },
    {
      header: "Public",
      accessorKey: "is_public",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsPublic}
        />
      ),
    },
  ];
  return (
    <>
      <div className={tw`grid grid-cols-4 gap-4 my-2`}>
        {!isLoading &&
          pinnedResults.map((form: any) => (
            <Card
              key={form.id}
              title={`TOTAL ${form.title.toUpperCase()}`}
              onClick={() => navigate(`/form-builder/data-collect/${form.id}`)}
            >
              <div className={tw`flex justify-between items-baseline`}>
                <span className={tw`text-2xl font-bold text-blue-600`}>
                  {submissionCounts[form.id] ?? 0}
                </span>
                <span className={tw`text-gray-400 text-sm italic`}>
                  Entries
                </span>
              </div>
            </Card>
          ))}
      </div>

      <DataTable
        queryKey={"pinned-forms"}
        url={APIS.FORM}
        params={{ pin: true }}
        columns={defaultColums}
        tableName="form-table"
      />

      {/* <Card title="Statistics">
            <div className={tw`h-[600px]`}>
              <ResponsiveBar
                data={salesData}
                keys={["Products"]}
                indexBy="day"
                margin={{ top: 20, right: 130, bottom: 80, left: 80 }}
                padding={0.3}
                valueScale={{ type: "linear" }}
                indexScale={{ type: "band", round: true }}
                theme={graphTheme}
                colors={[themeColor]}
                axisBottom={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Day of the Week",
                  legendPosition: "middle",
                  legendOffset: 50,
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Sales",
                  legendPosition: "middle",
                  legendOffset: -60,
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                legends={[
                  {
                    dataFrom: "keys",
                    anchor: "bottom-right",
                    direction: "column",
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: "left-to-right",
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    itemTextColor: "var(--primary)",
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
                animate={true}
              />
            </div>
          </Card> */}
    </>
  );
};
export default Overview;
